<template>
  <v-system-bar
    class="maintenance-banner blue darken-4"
    app
    dark
    height="30"
    v-if="bannerMessage && timeLeft"
  >
    <div class="marquee-container">
      <div class="marquee-content">
        <span class="banner-text">
          {{ bannerMessage }}
          <span v-if="countdownString" class="countdown-text">
            Countdown: {{ countdownString }}
          </span>
        </span>
        <span class="banner-text">
          {{ bannerMessage }}
          <span v-if="countdownString" class="countdown-text">
            Countdown: {{ countdownString }}
          </span>
        </span>
      </div>
    </div>
  </v-system-bar>
</template>

<script>
export default {
  name: "MaintenanceBanner",
  props: {
    bannerMessage: {
      type: String,
      default: "",
    },
    timeLeft: {
      type: [String, Date, Number],
      default: null,
    },
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      countdownInterval: null,
    };
  },
  computed: {
    countdownString() {
      if (
        !this.timeLeft ||
        (this.days === 0 &&
          this.hours === 0 &&
          this.minutes === 0 &&
          this.seconds === 0)
      ) {
        return "";
      }
      return `${this.days}:${String(this.hours).padStart(2, "0")}:${String(
        this.minutes,
      ).padStart(2, "0")}:${String(this.seconds).padStart(2, "0")}`;
    },
    targetDateTime() {
      if (!this.timeLeft) return null;

      if (typeof this.timeLeft === "string") {
        return new Date(this.timeLeft);
      } else if (typeof this.timeLeft === "number") {
        return new Date(this.timeLeft);
      }
      return this.timeLeft;
    },
  },
  mounted() {
    if (this.targetDateTime) {
      this.updateCountdown();
      this.countdownInterval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
  methods: {
    updateCountdown() {
      if (!this.targetDateTime) return;

      const now = new Date().getTime();
      const distance = this.targetDateTime.getTime() - now;

      if (distance < 0) {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }
        this.$store.dispatch("FETCH_MAINTENANCE_STATUS").catch((err) => {
          // console.error("Failed to fetch maintenance status:", err);
        });
        this.$emit("countdown-finished");
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    },
  },
};
</script>

<style scoped>
.maintenance-banner {
  width: 100%;
  color: white;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.marquee-container {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
}

.marquee-content {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 45s linear infinite;
}

.banner-text {
  display: inline-block;
  padding-right: 100px;
  font-weight: 500;
  font-size: 0.95rem;
  line-height: 30px;
}

.countdown-text {
  margin-left: 12px;
  font-weight: 700;
  font-family: "Courier New", monospace;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 4px;
}

@keyframes marquee {
  0% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Pause animation on hover */
.maintenance-banner:hover .marquee-content {
  animation-play-state: paused;
}
</style>
